import { useTranslation } from "@me8eon/translation";
import React, { useContext, useEffect } from "react";
import { AiAssistantContext } from "../../../context/AiAssistantContext";
import { Icon } from "@me8eon/icons";
import "./AssistanceTask.scss";
import LoaderComponent from "../../loader-component/LoaderComponent";
import { taskStatus } from "../action-components/nexthinkActions";

type TaskKeys =
    | "#disk_cleanup_deep"
    | "#disk_cleanup_light"
    | "#clear_chrome_cache"
    | "#repair_empower_addin"
    | "#clear_microsoft_edge_settings_gsd";
type StatusKeys = "success" | "failure" | "expired" | "progress";

const AssistanceTask = () => {
    const t = useTranslation();
    const { assistanceTasks, fetchStatusForInProgressTasks, removeOldAssistanceTask } = useContext(AiAssistantContext);

    useEffect(() => {
        const interval = setInterval(() => {
            removeOldAssistanceTask();
            fetchStatusForInProgressTasks();
        }, 30 * 1000); // 30 seconds

        return () => clearInterval(interval);
    }, [removeOldAssistanceTask, fetchStatusForInProgressTasks]);

    if (!assistanceTasks.length) return null;

    return (
        <div className="ai-assist-assistance-task">
            <div className="heading" title={t("chatBot.nexthinkIntegration.assistanceTask")}>
                <Icon size="normal" name="plus_circle" />
                <span>{t("chatBot.nexthinkIntegration.assistanceTask")}</span>
            </div>
            <div className="assistance-task-wrapper">
                {assistanceTasks
                    .slice()
                    .reverse()
                    .map((item) => (
                        <div
                            className="assistance-task-item"
                            key={item.requestId}
                        >
                            <span>
                                {item.status === "progress" ? (
                                    <LoaderComponent
                                        isLoading={true}
                                        isInline
                                        size="small"
                                    />
                                ) : (
                                    <Icon
                                        size="small"
                                        name={
                                            item.status === "success"
                                                ? "tick_small"
                                                : "task_failed"
                                        }
                                        {...(item.status === "success" && {
                                            themedColor: "#EA1B0A",
                                        })}
                                    />
                                )}
                            </span>
                            <span>
                                {t(
                                    taskStatus[item.task as TaskKeys][
                                        item.status as StatusKeys
                                    ]
                                )}
                            </span>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default AssistanceTask;
